import moment from 'moment';

export class MomentHelper {
    // TODO fix Date | string, make this more strict

    static dateWithoutTimezone(date: Date | string): string {
        return moment(date).format('YYYY-MM-DDTHH:mm:ss');
    }

    static dateWithoutSeconds(date: Date): Date {
        return new Date(moment(date).format('YYYY-MM-DDTHH:mm'));
    }

    static startOfDay(date: Date = new Date()): Date {
        return moment(date).startOf('day').toDate();
    }

    static endOfDay(date: Date = new Date()): Date {
        return moment(date).endOf('day').toDate();
    }
}
